import { BaseOnAddItem, ScreenContext, useCollection } from '@hb/react'
import { Collection, FieldMapValue, Template, TemplateKey } from '@hb/shared'
import React, { useCallback, useContext } from 'react'
import { TemplateContext } from '../../contexts/TemplateContext'
import EditCollection from '../EditCollection/EditCollection'
import { AddConsentForm } from './ConsentForms/AddConsentForm'
import { ConsentFormItemActions } from './ConsentForms/ConsentFormItemActions'
import { TemplatePreview } from './TemplatePreview'
import { addExternalPdfTemplate } from './utils'

export const TemplatesSection: React.FC<{
  collection: Collection<Template>
  templateType: TemplateKey
  canBeExternalPdf?: boolean
}> = ({ collection, templateType }) => {
  const { name } = collection
  const collectionData = useCollection(collection)
  const { contentWidth } = useContext(ScreenContext)

  const onAdd = useCallback(
    async (data: FieldMapValue, fallback: BaseOnAddItem) => {
      if (templateType === 'consentForm' && data.isExternalPdf) {
        try {
          await addExternalPdfTemplate({
            templateType,
            name: data.name,
            isExternalPdf: data.isExternalPdf,
            externalPdf: data.externalPdf,
            practiceId: null,
          })
          return { success: 'Template added' }
        } catch (e: any) {
          console.error(e)
          return { error: e.message }
        }
      }
      return fallback(data)
    },
    [templateType],
  )

  const { select } = useContext(TemplateContext)
  return collectionData ? (
    <EditCollection<Template>
      data={collectionData}
      width={contentWidth}
      collection={collection}
      onOpenItem={id => {
        if (select) select({ collection, templateId: id, templateType })
      }}
      ItemComponent={
        templateType === 'consentForm'
          ? props => TemplatePreview({ ...props, collection, templateType })
          : undefined
      }
      ItemActions={templateType === 'consentForm' ? ConsentFormItemActions : undefined}
      alwaysExpanded={true}
      onAdd={onAdd}
      name={name}
      RenderAddItem={templateType === 'consentForm' ? AddConsentForm : undefined}
      itemPlaceholder="Template Name"
      itemName="Template"
    />
  ) : null
}
